<template>
  <el-container class='box'>
    <div class="headerCom"> 
      <publicBreadCrumb :breadList="breadList"/>
      <publicFoldSearch :searchList='searchList' v-on:getSearchObj='getSearchObj'  :rightEventList='rightEventList' @rightFunc='rightFunc'/>
     </div>
    <el-main class="listTabel">
      <BaseTable :data="tableData" :optimize='true'
          tooltip-effect="dark"
          :column="tableConfig" pagination :auto-scroll="true" :total="total" :page.sync="searchParams.current"
          :limit.sync="searchParams.size" @pagination="getList">
      </BaseTable>
    </el-main> 
  </el-container>
</template>

<script>
import { searchChannel,getChannelType } from "@/api/cooperateChannelManage"

// import {
//   getWeChatAppList,
//   outsideChainProjectPage,
//   listHospitalAllPullDown,
//   findIcdDiseaseList,
//   publish
// } from "./api";
// import { DEEP_CLONE } from '@/utils/constants'
export default {
  components: {

  },
  props: {},
  data() {
    return {
      breadList:[{name:'运营管理'},{name:'合作渠道管理'}],
      rightEventList:[{eventName:'新增渠道机构',eventValue:1}],
      // tableDataCode: [
      //   { size: "150*150", val: "150" },
      //   { size: "256*256", val: "256" },
      //   { size: "512*512", val: "512" },
      //   { size: "1024*1024", val: "1024" }
      // ],
      curRow: {},
      searchList: [
        {
          label: "机构名称",
          value: 1,
          paramName: "orgName",
          inputType: "input"
        },
        {
          label: "合作状态",
          value: 2,
          paramName: "state",
          inputType: "select",
          default: null,
          optionData: [
            {
              label: "进行中",
              value: 1
            },
            {
              label: "已过期",
              value: 2
            },
            {
              label: "未开始",
              value: 3
            }
          ]
        },
        {
          label: "渠道类型",
          value: 3,
          paramName: "channelType",
          inputType: "select",
          optionData: []
        }
      ],
      searchParams: {
        size: 10,
        current: 1, 
      }, 
      tableData: [],
      tableConfig: [ 
        {
          label: "合作类型",
          align: "center",
          showOverflowTooltip:true,
          render: (h, scope) => {
            return (
              <span slot="reference">
                {scope.row.cooperationType.length ? scope.row.cooperationType.map(v => v.cooperationTypeName).join('、') : '-'}
              </span>
            );
          }
        },
        {
          label: "渠道类型",
          align: "center",
          prop: "channelTypeName",
          size: "mini"
        },
        {
          label: "机构名称",
          align: "center",
          prop: "orgName" 
        },
        {
          label: "合作服务",
          align: "center",
          prop: "cooperationServiceName" 
        },
        {
          label: "合作起始",
          align: "center",
          prop: "beginTime" 
        }, 
        {
          label: "合作截止",
          align: "center",
          prop: "endTime", 
        },
        {
          label: "合作状态",
          align: "center",
          render: (h, scope) => {
            if (scope.row.state == 1) {
              return (
                <span slot="reference" style="display:inline-block;background: #D3F3E2;height:24px;line-height:24px;width:54px;text-align:center;">
                  进行中
                </span>
              )
            }
            if (scope.row.state == 2) {
              return (
                <span slot="reference" style="display:inline-block;background: #EEEEEE;height:24px;line-height:24px;width:54px;text-align:center;">
                  已过期
                </span>
              )
            }
            if (scope.row.state == 3) {
              return (
                <span slot="reference" style="display:inline-block;background: #D3F3E2;height:24px;line-height:24px;width:54px;text-align:center;">
                  未开始
                </span>
              )
            }
            // return (
            //   // <span slot="reference">
            //   //   {scope.row.state == 1
            //   //     ? "进行中"
            //   //     : scope.row.state == 2
            //   //     ? "已过期"
            //   //     : "未开始"}
            //   // </span>

            //   // <div>
            //   //   <span>进行中</span>
            //   //   <el-button
            //   //     size="mini"
            //   //     type="text"
            //   //     onClick={() => this.hometHandel(scope, 2)}
            //   //   >
            //   //     发送
            //   //   </el-button>
            //   // </div>
            // );
          }
        },
        {
          label: "启用",
          align: "center",
          render: (h, scope) => {
            if (scope.row.disabled) {
              return (
                <span slot="reference" style="display:inline-block;background: #FCB023;height:24px;line-height:24px;width:44px;text-align:center;color:#FFFFFF">
                  禁用
                </span>
              )
            }
            if (!scope.row.disabled) {
              return (
                <span slot="reference" style="display:inline-block;background: #0CB79F;height:24px;line-height:24px;width:44px;text-align:center;color:#FFFFFF">
                  启用
                </span>
              )
            }
            // return (
            //   <span slot="reference">
            //     {scope.row.disabled ? "禁用" : "启用"}
            //   </span>
            // );
          }
        },
        {
          label: "操作",
          align: "center",
          width: "200px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.onLookClick(scope.row);
                    }
                  }
                },
                "查看"
              ),
               h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.editClick(scope.row);
                    }
                  }
                }, 
                "编辑" 
              )
            ]);
          }
        }
      ],
      total: 0
    };
  },

  watch: {},
  computed: {},
  created() {
    this.getInitData()
    this.getList();
  },
  methods: {
    onLookClick(row) {
      // this.$router.push("/termPage/addCooperateChannel");
      this.$router.push({
        path: "/termPage/addCooperateChannel",
        query: { type: 'view',id: row.id}
      });
    },
    async getInitData() {
      let res = await getChannelType()
      if (res.code == 0) {
        res.data.map(v => {
          v.label = v.name
          v.value = v.id
        })
        this.searchList[2].optionData = res.data
      }
    },

    editClick(row) {
      this.$router.push({
        path: "/termPage/addCooperateChannel",
        query: { type: 'edit',id: row.id}
      });
    },
    showDownLoad(row) {
      this.curRow = row;
      this.$refs.code.showDialogCode();
    },
    onAddClick(data) {
      this.$copyText(data)
        .then(result => {
          this.$message.success("复制成功");
        })
        .catch(err => {});
    },
    getSearchObj(obj) {
      //清空之前合并过的条件
      this.searchParams = this.$options.data().searchParams; 
      this.searchParams = { ...this.searchParams, ...obj }; 
      this.getList();
    }, 
    async getList() {
      console.log(this.searchParams)
      let res = await searchChannel(this.searchParams)
      if (res.code == 0) {
        this.total = res.data.total;
        this.tableData = res.data.records;
      }
    },
    addOuterChain() {
      this.$router.push("/termPage/addOuterChain");
    },
    // handleSizeChange(value) {
    //   this.searchParams.size = value;
    //   this.getList();
    // },
    // handleCurrentChange(value) {
    //   this.searchParams.current = value;
    //   this.getList();
    // },
    // enableTheClick(row) {
    //   //启用
    //   publish({ id: row.id }).then(res => {
    //     if (res.code == 0) {
    //       this.getList();
    //       if(scope.row.status){
    //         this.$message.success("启用成功");
    //       }else{
    //         this.$message.success("禁用成功");
    //       }
          
    //     }
    //   });
    // },
    // disableClick(row) {
    //   //禁用
    //   publish({ id: row.id }).then(res => {
    //     if (res.code == 0) {
    //       this.getList();
    //       this.$message.success("禁用成功");
    //     }
    //   });
    // },
    rightFunc(item) {
      // if(item.eventValue == 1){
      //    this.$router.push("/termPage/addCooperateChannel");
      // }
      this.$router.push({
        path: "/termPage/addCooperateChannel",
        query: { type: 'add' }
      });
    }, 
    setValueNull(e){ 
      this.searchParams.status = 0;
        // this.searchParamsNew.status = null;
    },
  },
  // created() {
    // getWeChatAppList(1)
    //   .then(result => {
    //     let arr = result.data.map(it => {
    //       return {
    //         label: it.name,
    //         value: it.appId
    //       };
    //     });
    //     // this.WeChatAppList = result.data
    //     this.searchList[1].optionData = arr;
    //   })
    //   .catch(err => {});
    // outsideChainProjectPage({})
    //   .then(result => {
    //     let arr = result.data.map(it => {
    //       return {
    //         label: it.name,
    //         value: it.id
    //       };
    //     });
    //     // this.chainProjectList = result.data; 
    //     this.searchList[2].optionData = arr 
    //   })
    //   .catch(err => {});

    // findIcdDiseaseList("")
    //   .then(result => {
    //     let arr = result.data.map(it => {
    //       return {
    //         label: it.suborderName,
    //         value: it.id,
    //         disabled:it.id == '36112'?true:false
    //       };
    //     });
    //     // this.diseaseArr = result.data;
    //     this.searchList[4].optionData = arr;
    //   })
    //   .catch(err => {}); 
    // // this.getList();
  // },
  mounted() {}
};
</script>
<style lang="less" scoped>
.box {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/deep/.el-pagination {
  text-align: right;
  margin-top: 30px;
  margin-right: 30px;
  padding-bottom: 20px;
}
.mr10{margin-right:10px;}
/deep/.el-form-item{
  margin-right:10px;
  margin-bottom:0;
}
/deep/.el-tag{
  margin-left:5px;
}
</style>